// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ITransactionDto } from './ITransactionDto';
import {
    ITransactionDtoFromJSON,
    ITransactionDtoFromJSONTyped,
    ITransactionDtoToJSON,
    ITransactionDtoToJSONTyped,
} from './ITransactionDto';
import type { IPageableObject } from './IPageableObject';
import {
    IPageableObjectFromJSON,
    IPageableObjectFromJSONTyped,
    IPageableObjectToJSON,
    IPageableObjectToJSONTyped,
} from './IPageableObject';
import type { ISortOrder } from './ISortOrder';
import {
    ISortOrderFromJSON,
    ISortOrderFromJSONTyped,
    ISortOrderToJSON,
    ISortOrderToJSONTyped,
} from './ISortOrder';

/**
 * 
 * @export
 * @interface IPageTransactionDto
 */
export interface IPageTransactionDto {
    /**
     * 
     * @type {number}
     * @memberof IPageTransactionDto
     */
    total_pages?: number;
    /**
     * 
     * @type {number}
     * @memberof IPageTransactionDto
     */
    total_elements?: number;
    /**
     * 
     * @type {number}
     * @memberof IPageTransactionDto
     */
    size?: number;
    /**
     * 
     * @type {Array<ITransactionDto>}
     * @memberof IPageTransactionDto
     */
    content?: Array<ITransactionDto>;
    /**
     * 
     * @type {number}
     * @memberof IPageTransactionDto
     */
    number?: number;
    /**
     * 
     * @type {Array<ISortOrder>}
     * @memberof IPageTransactionDto
     */
    sort?: Array<ISortOrder>;
    /**
     * 
     * @type {IPageableObject}
     * @memberof IPageTransactionDto
     */
    pageable?: IPageableObject;
    /**
     * 
     * @type {number}
     * @memberof IPageTransactionDto
     */
    number_of_elements?: number;
    /**
     * 
     * @type {boolean}
     * @memberof IPageTransactionDto
     */
    first?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IPageTransactionDto
     */
    last?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IPageTransactionDto
     */
    empty?: boolean;
}

/**
 * Check if a given object implements the IPageTransactionDto interface.
 */
export function instanceOfIPageTransactionDto(value: object): value is IPageTransactionDto {
    return true;
}

export function IPageTransactionDtoFromJSON(json: any): IPageTransactionDto {
    return IPageTransactionDtoFromJSONTyped(json, false);
}

export function IPageTransactionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPageTransactionDto {
    if (json == null) {
        return json;
    }
    return {
        
        'total_pages': json['totalPages'] == null ? undefined : json['totalPages'],
        'total_elements': json['totalElements'] == null ? undefined : json['totalElements'],
        'size': json['size'] == null ? undefined : json['size'],
        'content': json['content'] == null ? undefined : ((json['content'] as Array<any>).map(ITransactionDtoFromJSON)),
        'number': json['number'] == null ? undefined : json['number'],
        'sort': json['sort'] == null ? undefined : ((json['sort'] as Array<any>).map(ISortOrderFromJSON)),
        'pageable': json['pageable'] == null ? undefined : IPageableObjectFromJSON(json['pageable']),
        'number_of_elements': json['numberOfElements'] == null ? undefined : json['numberOfElements'],
        'first': json['first'] == null ? undefined : json['first'],
        'last': json['last'] == null ? undefined : json['last'],
        'empty': json['empty'] == null ? undefined : json['empty'],
    };
}

export function IPageTransactionDtoToJSON(json: any): IPageTransactionDto {
    return IPageTransactionDtoToJSONTyped(json, false);
}

export function IPageTransactionDtoToJSONTyped(value?: IPageTransactionDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalPages': value['total_pages'],
        'totalElements': value['total_elements'],
        'size': value['size'],
        'content': value['content'] == null ? undefined : ((value['content'] as Array<any>).map(ITransactionDtoToJSON)),
        'number': value['number'],
        'sort': value['sort'] == null ? undefined : ((value['sort'] as Array<any>).map(ISortOrderToJSON)),
        'pageable': IPageableObjectToJSON(value['pageable']),
        'numberOfElements': value['number_of_elements'],
        'first': value['first'],
        'last': value['last'],
        'empty': value['empty'],
    };
}

